let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8LOW4")).then(() => parcelRequire('86c8j'));